import React from 'react';
import { ScaffolderPage } from '@backstage/plugin-scaffolder';
import { Tooltip, IconButton } from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  backButton: {
    marginTop: '16px',
  },
  scaffolderDiv: {
    padding: '20px'
  }

});

const CustomScaffolderPage = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  return (

    <div>
      {/* <Tooltip title="Back" className={classes.backButton}>
        <IconButton onClick={() => navigate(-1)}>
          <ArrowBackIosIcon />
        </IconButton>
      </Tooltip> */}
      {/* <div className={classes.scaffolderDiv}> */}
        <ScaffolderPage />
      {/* </div> */}
    </div>

  );
};

export default CustomScaffolderPage;
